import { render, staticRenderFns } from "./PurchasePassCard.vue?vue&type=template&id=5c7336ea&scoped=true&"
import script from "./PurchasePassCard.vue?vue&type=script&lang=js&"
export * from "./PurchasePassCard.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePassCard.vue?vue&type=style&index=0&id=5c7336ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7336ea",
  null
  
)

export default component.exports